import React from "react";

import { useDictionary } from "hooks";
import { CAYUSE_TYPES } from "globals/constants";

import Integration from "./Integration";


function AnimalProtocolSearch (props) {
	const dictionary = useDictionary('animalProtocolSearch');

	return <Integration title={dictionary.headline ?? 'Link to Animal Protocols'} { ...props }/>;
}

AnimalProtocolSearch.showInPalette = () => true;

AnimalProtocolSearch.paletteInformation = () => ({
	id: "cayuseAnimalOversight",
	name: "Animal Protocol Search",
	type: "cayuseAnimalOversight",
	group: "sponsoredProject"
});

AnimalProtocolSearch.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-animal-oversight",
		customStencilId: "null"
	},
	type: CAYUSE_TYPES.ANIMAL_OVERSIGHT,
	cayuseShortLabel: "Animal Protocol Search"
});

AnimalProtocolSearch.initialValue = "{{animalOversight}}";


export default AnimalProtocolSearch;
